var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ready)?_c('div',{staticClass:"uncommon-container",class:_vm.$mq},[_c('div',{staticClass:"contents-container"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('message.demo.pageName')))]),_c('demo-cd-list',{attrs:{"is-center":true}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }